export default __webpack_public_path__ + "static/dresses-results-1-79390f80bbaa9673868ee451f8ba9584.png";